export default __webpack_public_path__ + "static/media/Drazo.d18c0bf4.jpeg";